<template>
    <form @submit.prevent="submitReport">
        <div class="md-layout mt-2">
            <div class="md-layout-item md-size-100">
                <div class="md-input-radio">
                    <label>Contrôle *</label>
                    <div>
                        <md-radio v-model="report.isControlled" class="mt-2" :value="true">Oui</md-radio>
                        <md-radio v-model="report.isControlled" class="mt-2" :value="false">Non</md-radio>
                    </div>
                </div>
            </div>
        </div>
        <template v-if="report.isControlled">
            <div class="md-layout -mt-4">
                <div class="md-layout-item md-size-100">
                    <div class="md-multiselect">
                        <label>Nombre de captures *</label>
                        <multiselect v-model="report.capture"
                                     :options="config.captures"
                                     :searchable="false"
                                     :show-labels="false"
                                     :allow-empty="false"
                                     label="value"
                                     track-by="value">
                            <template slot="noOptions">La liste est vide</template>
                            <template slot="noResult">Aucun élement correspondant</template>
                        </multiselect>
                    </div>
                </div>
            </div>
            <div class="md-layout mt-2">
                <div class="md-layout-item md-size-100">
                    <div class="md-input-radio">
                        <label>Remplacement GLU *</label>
                        <div>
                            <md-radio v-model="report.isGlueReplaced" class="mt-2" :value="true">Oui</md-radio>
                            <md-radio v-model="report.isGlueReplaced" class="mt-2" :value="false">Non</md-radio>
                        </div>
                    </div>
                </div>
            </div>
            <div class="md-layout -mt-3">
                <div class="md-layout-item md-size-100">
                    <div class="md-multiselect md-multiselect-multiple">
                        <label>Commentaires</label>
                        <multiselect v-model="report.comments"
                                     :options="config.comments"
                                     :multiple="true"
                                     :searchable="false"
                                     :close-on-select="false"
                                     :show-labels="false"
                                     label="label"
                                     track-by="id"
                                     placeholder="Commentaires">
                            <template slot="noOptions">La liste est vide</template>
                            <template slot="noResult">Aucun élement correspondant</template>
                        </multiselect>
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="md-layout -mt-2">
                <div class="md-layout-item md-size-100">
                    <div class="md-multiselect">
                        <label>Raison *</label>
                        <multiselect v-model="report.reason"
                                     :options="config.reasons"
                                     :searchable="false"
                                     :show-labels="false"
                                     :allow-empty="false"
                                     label="label"
                                     track-by="id">
                            <template slot="noOptions">La liste est vide</template>
                            <template slot="noResult">Aucun élement correspondant</template>
                        </multiselect>
                    </div>
                </div>
            </div>
        </template>
        <div class="md-layout mt-2">
            <div class="md-layout-item md-size-100">
                <md-field class="md-invalid">
                    <label>Commentaire libre</label>
                    <md-textarea v-model="report.freeComment" name="comment" md-autogrow></md-textarea>
                </md-field>
            </div>
        </div>
	    <md-divider class="mt-3 mb-4 -mx-3"></md-divider>
        <div class="md-layout">
            <div class="md-layout-item md-size-100">
                <div class="md-multiselect">
                    <label>Changement de dispositif</label>
                    <multiselect v-model="report.newDeviceType"
                                 placeholder="Type de dispositifs"
                                 :options="config.deviceTypes"
                                 :searchable="false"
                                 :show-labels="false"
                                 label="name"
                                 track-by="name"
                                 return="id">
                        <template slot="singleLabel" slot-scope="props">
                            <img class="option__image" :src="props.option.icon" alt="picto">
                            <span class="option__desc">
                                <span class="option__title">{{ props.option.name }}</span>
                            </span>
                        </template>
                        <template slot="option" slot-scope="props">
                            <img class="option__image" :src="props.option.icon" alt="picto">
                            <div class="option__desc">
                                <span class="option__title">{{ props.option.name }}</span>
                            </div>
                        </template>
                        <template slot="noOptions">La liste est vide</template>
                        <template slot="noResult">Aucun élement correspondant</template>
                    </multiselect>
                </div>
            </div>
        </div>
	    <md-divider class="my-2 -mx-3"></md-divider>
        <div class="mb-1.5 text-right">
	        <md-button class="md-success md-icon-button md-raised my-0" type="submit" :disabled="loading">
		        <font-awesome-icon class="md-icon" :icon="['fa', loading ? 'sync-alt' : 'check-circle']" :class="{'animate-spin': loading}" />
		        <span class="leading-none font-medium ml-2">Créer la fiche de suivi</span>
	        </md-button>
        </div>
    </form>
</template>

<script>
import { mapState } from "vuex";

import indexedDBMixin from "@/mixins/indexed-db-mixin";
import indexedDBDeviceReportMixin from "@/mixins/indexed-db-device-report-mixin";

export default {
    name: "ReportModel2",
	mixins: [indexedDBMixin, indexedDBDeviceReportMixin],
    props: {
        device: Object,
	    reportType: Object,
	    reportConfig: Object
    },
    data() {
        return {
            config: {
                captures: [
                    { value: 0 },
                    { value: 1 },
                    { value: 2 },
                    { value: 3 },
                    { value: 4 },
                    { value: 5 },
                    { value: 6 },
                    { value: 7 },
                    { value: 8 },
                    { value: 9 },
                    { value: 10 },
                ],
                comments: [],
                reasons: [],
                deviceTypes: []
            },
            report: {
                isControlled: true,
                capture: { value: 0 },
                isGlueReplaced: false,
                comments: [{ id: 0, label: 'RAS'}],
                reason: { id: 0, label: 'Manquant' },
                newDeviceType: null,
                freeComment: '',
            },
	        loading: false
        }
    },
    computed: mapState({
        user: state => state.pwaAuth.technician,
    }),
    methods: {
        async submitReport() {
			this.loading = true

            try {
                const isControlled = this.report.isControlled
                const payload = {
                    access_token: JSON.parse(localStorage.getItem('pwa')).access_token,
                    device_id: this.device.id,
                    is_same_intervention_type: this.device.isSameInterventionType,
                    user_id: this.user.id,
                    json: JSON.stringify({
                        isControlled: isControlled ? '1' : '0',
                        isGlueReplaced: isControlled ? (this.report.isGlueReplaced ? '1' : '0') : 'null',
                        comments: isControlled ? (this.report.comments.length > 0 ? this.report.comments.map(comment => comment.id.toString()).sort() : 'null') : 'null',
                        freeComment: this.report.freeComment,
                        reasonId: isControlled ? 'null' : this.report.reason.id.toString(),
                    }),
                    new_device_type_id: this.report.newDeviceType?.id,
                    device_report_type_id: this.reportType.id,
                    intervention_id: parseInt(this.$route.params.interventionId),
                    capture: isControlled ? this.report.capture.value : null,
                }

	            await this.storeDeviceReport(`pwa/device/${payload.device_id}/${payload.intervention_id}/report`, payload)
                await this.$store.dispatch('alerts/success', 'Fiche de suivi créée')
                await this.$router.back()
            } catch (e) {
	            this.loading = false
	            await this.$store.dispatch('alerts/error', 'Une erreur est survenue')
            }
        }
    },
    mounted() {
        this.config = {
		    ...this.config,
		    ...this.reportConfig,
		    deviceTypes: this.reportType.deviceTypes,
	    }
    },
    watch: {
        'report.comments'(newVal) {
            if(newVal.length > 1) {
                const index = newVal.findIndex(comment => comment.id === 0)
                if(index >= 0) {
                    newVal.splice(index, 1)
                }
            } else if(newVal.length === 0) {
                this.report.comments = [{ id: 0, label: 'RAS'}]
            }
        }
    }
}
</script>

<style scoped>

</style>
